<template lang="pug">
form#ministry-form(name="ministry-form" @submit.prevent="submit" novalidate)
  .modal-card
    header.modal-card-head
      p.modal-card-title(v-once) {{ title }}
    section.modal-card-body.modal-tabs
      b-tabs(
        position="centered"
        :animated="false"
        expanded
      )
        b-tab-item(label="Details")
          b-field(
            label="Name"
            :message="errors.has('name') ? errors.first('name') : ''"
            :type="errors.has('name') ? 'is-danger' : ''"
          )
            b-input(
              name="name"
              v-validate="'required'"
              :value="ministry.name"
              @input="set($event, 'name')"
            )
          b-field(
            label="URL"
            :message="errors.has('url') ? errors.first('url') : ''"
            :type="errors.has('url') ? 'is-danger' : ''"
          )
            b-field(:type="errors.has('url') ? 'is-danger' : ''")
              p.control
                span.button.is-static {{ account.host }}/ministries/
              b-input(
                type="text"
                name="url"
                v-validate="{ required: true, unique: { id: ministry.id, resource: 'ministries', fieldName: 'URL' } }"
                data-vv-as="URL"
                :value="ministry.key"
                @input="set($event, 'key')"
                expanded
                required
              )
          b-field(label="Age/Grade Range")
            b-input(
              name="age_range"
              :value="ministry.age_range"
              @input="set($event, 'age_range')"
            )
          b-field(label="Preview")
            b-input(
              name="short_desc"
              type="textarea"
              rows="3"
              :value="ministry.short_desc"
              @input="set($event, 'short_desc')"
            )
        b-tab-item(label="Contact")
          .media
            .media-left
              cover-art-tab(
                v-model="images.contact"
                :default-image="defaultContactImage"
                :height="140"
                :width="140"
                :caption="false"
                @input="img => images.contact = img"
              )
            .media-content
              b-field(label="Contact Name")
                b-input(
                  :value="ministry.contact_name"
                  @input="set($event, 'contact_name')"
                )
              b-field(label="Contact Title")
                b-input(
                  :value="ministry.contact_title"
                  @input="set($event, 'contact_title')"
                )
          b-field(label="Email")
            b-input(
              type="email"
              icon="email"
              :value="ministry.email"
              @input="set($event, 'email')"
              expanded
            )
          b-field(label="Phone Number")
            phone-field(
              type="text"
              icon="cellphone"
              :value="ministry.phone_number"
              @input="set($event, 'phone_number')"
              expanded
            )
          b-field(label="Facebook")
            b-input(
              icon="facebook"
              :value="ministry.social.facebook"
              @input="set($event, 'social.facebook')"
            )
          b-field(label="Instagram")
            b-input(
              icon="instagram"
              :value="ministry.social.instagram"
              @input="set($event, 'social.instagram')"
            )
          b-field(label="Twitter")
            b-input(
              icon="twitter"
              :value="ministry.social.twitter"
              @input="set($event, 'social.twitter')"
            )
          b-field(label="YouTube")
            b-input(
              icon="youtube"
              :value="ministry.social.youtube"
              @input="set($event, 'social.youtube')"
            )
        //- b-tab-item(label="Roles")
        //-   .ministry-roles
        //-     b-table(
        //-       v-if="ministry._embedded.roles && ministry._embedded.roles.length > 0"
        //-       :data="ministry._embedded.roles"
        //-     )
        //-       template(slot-scope="props")
        //-         b-table-column(label="Staff Member")
        //-           b-autocomplete(
        //-             icon="magnify"
        //-             field="full_name"
        //-             placeholder="Search..."
        //-             :data="options"
        //-             :value="props.row.staff_member.full_name"
        //-             @typing="searchStaffMembers"
        //-             @select="setStaffMember($event, props.index)"
        //-             keep-first
        //-           )
        //-         b-table-column(label="Title")
        //-           b-input(
        //-             :value="props.row.title"
        //-             @input="setRole($event, props.index, 'title')"
        //-           )
        //-         b-table-column(label="Ministry Head" width="100")
        //-           b-switch(
        //-             :value="props.row.is_head"
        //-             @input="setRole($event, props.index, 'is_head')"
        //-           )
        //-         b-table-column(numeric)
        //-           b-field(grouped)
        //-             p.control
        //-               a.button(@click="addRole(props.index)")
        //-                 b-icon(icon="plus")
        //-             p.control
        //-               a.button.is-danger(
        //-                 :disabled="ministry._embedded.roles.length === 1"
        //-                 @click="confirmDeleteRole(props.index)"
        //-               )
        //-                 b-icon(icon="close")
        b-tab-item(label="Page")
          b-field(label="Main Gallery")
            b-upload(
              v-model="uploads.main"
              @input="saveImage($event, 'main')"
              multiple
              drag-drop
            )
              section.section
                .content.has-text-centered
                  b-icon(icon="image-multiple" size="is-large")
                  p Drop an image
                  progress.progress.is-small.is-primary(
                    :value="settings.uploading.main"
                    max="100"
                    v-show="settings.uploading.main > 0"
                  )
          gallery-uploads(
            :value="ministry._embedded.main_gallery"
            @delete="deleteImage($event, 'main')"
            @sort="sortImages($event, 'main')"
          )
          b-field(label="Main Heading")
            b-input(
              name="main_heading"
              :value="ministry.main_heading"
              @input="set($event, 'main_heading')"
            )
          b-field(label="Main Body")
            b-input(
              name="main_body"
              type="textarea"
              rows="6"
              :value="ministry.main_body"
              @input="set($event, 'main_body')"
            )
          hr
          b-field(label="Service Times Gallery")
            b-upload(
              v-model="uploads.service"
              @input="saveImage($event, 'service')"
              multiple
              drag-drop
            )
              section.section
                .content.has-text-centered
                  b-icon(icon="image-multiple" size="is-large")
                  p Drop an image
                  progress.progress.is-small.is-primary(
                    :value="settings.uploading.service"
                    max="100"
                    v-show="settings.uploading.service > 0"
                  )
          gallery-uploads(
            :value="ministry._embedded.service_gallery"
            @delete="deleteImage($event, 'service')"
            @sort="sortImages($event, 'service')"
          )
          b-field(label="Service Times Heading")
            b-input(
              name="service_heading"
              :value="ministry.service_heading"
              @input="set($event, 'service_heading')"
            )
          b-field(label="Service Times Body")
            b-input(
              name="service_body"
              type="textarea"
              rows="6"
              :value="ministry.service_body"
              @input="set($event, 'service_body')"
            )
        b-tab-item(label="Profile Image")
          cover-art-tab(
            v-model="images.profile"
            :default-image="defaultProfileImage"
            :height="293"
            :width="293"
            @input="img => images.profile = img"
          )
        b-tab-item(label="Header Image")
          cover-art-tab(
            v-model="images.header"
            :default-image="defaultHeaderImage"
            @input="img => images.header = img"
          )
    footer.modal-card-foot
      button.button.is-success(
        type="submit"
        :class="{ 'is-loading': settings.submitting }"
      ) Save Ministry
      a.button.is-danger(v-if="!isNew" @click="confirmDelete") Delete
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { HTTP, SEARCH } from '@/utils/http';
import CoverArtTab from '@/components/form/episode/CoverArtTab';
import GalleryUploads from '@/components/GalleryUploads';
import PhoneField from '@/components/form/PhoneField';
import WeekdaySelect from '@/components/form/WeekdaySelect';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'ministry-form',
  components: {
    CoverArtTab,
    GalleryUploads,
    PhoneField,
    WeekdaySelect,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      ministry: getters.GET_MINISTRY,
    }),
    defaultContactImage() {
      if (this.ministry.contact_image) {
        return this.ministry.contact_image.file.url;
      }
      return null;
    },
    defaultHeaderImage() {
      if (this.ministry._embedded.header_image.id) {
        return this.ministry._embedded.header_image.file.url;
      }
      return null;
    },
    defaultMainImage() {
      if (this.ministry._embedded.main_image.id) {
        return this.ministry._embedded.main_image.file.url;
      }
      return null;
    },
    defaultProfileImage() {
      if (this.ministry._embedded.profile_image.id) {
        return this.ministry._embedded.profile_image.file.url;
      }
      return null;
    },
    defaultServiceImage() {
      if (this.ministry._embedded.service_image.id) {
        return this.ministry._embedded.service_image.file.url;
      }
      return null;
    },
    isNew() {
      return this.ministry.id === undefined;
    },
    title() {
      return this.isNew ? 'New Ministry' : `Edit Ministry: ${this.ministry.name}`;
    },
  },
  data() {
    return {
      images: {
        contact: null,
        header: null,
        profile: null,
      },
      options: [],
      uploads: {
        main: [],
        service: [],
      },
      settings: {
        loading: false,
        submitting: false,
        uploading: {
          main: false,
          service: false,
        },
      },
    };
  },
  methods: {
    // addRole(index) {
    //   this.$store.commit(mutations.INSERT_ROLE_FOR_MINISTRY, {
    //     index: index + 1,
    //     val: {
    //       staff_member: {},
    //     },
    //   });
    // },
    confirmDelete() {
      this.$buefy.dialog.confirm({
        title: 'Are you sure?',
        message: 'Deleting this ministry cannot be undone',
        type: 'is-danger',
        hasIcon: true,
        confirmText: 'Yes, Delete Ministry',
        onConfirm: () => this.deleteMinistry(),
      });
    },
    // confirmDeleteRole(index) {
    //   if (this.ministry._embedded.roles.length > 1) {
    //     const role = this.ministry._embedded.roles[index];
    //     if (role.id === undefined) {
    //       this.$store.commit(mutations.REMOVE_ROLE_FOR_MINISTRY, {
    //         index,
    //       });
    //     } else {
    //       this.$buefy.dialog.confirm({
    //         title: 'Are you sure?',
    //         message: 'Deleting this ministry role cannot be undone',
    //         type: 'is-danger',
    //         hasIcon: true,
    //         confirmText: 'Yes, Delete Ministry Role',
    //         onConfirm: () => this.deleteMinistryRole(index),
    //       });
    //     }
    //   }
    // },
    async deleteImage(index, key) {
      const image = this.ministry._embedded[`${key}_gallery`][index];
      this.$store.dispatch(actions.DO_DELETE_MEDIA, {
        id: image.id,
      });
      this.$store.commit(mutations.REMOVE_FROM_GALLERY_FOR_MINISTRY, {
        key: `${key}_gallery`,
        index,
      });
    },
    async deleteMinistry() {
      const response = await this.$store.dispatch(actions.DO_DELETE_MINISTRY, {
        id: this.ministry.id,
        ignore: true,
      });
      this.$parent.close();
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: response.message,
      });
      this.$store.commit(mutations.SET_MINISTRY_REFRESH, true);
    },
    // async deleteMinistryRole(index) {
    //   const role = this.ministry._embedded.roles[index];
    //   const response = await this.$store.dispatch(actions.DO_DELETE_MINISTRY_ROLE, {
    //     id: role.id,
    //   });
    //   this.$store.commit(mutations.REMOVE_ROLE_FOR_MINISTRY, {
    //     index,
    //   });
    //   this.$store.commit(mutations.SET_APP_SNACKBAR, {
    //     type: 'is-success',
    //     message: response.message,
    //   });
    // },
    async saveImage($event, key) {
      this.settings.uploading[key] = 0;
      const self = this;
      const upload = this.uploads[key];
      const payload = new FormData();
      payload.append('format', 'multipart');
      payload.append('file', upload[upload.length - 1]);
      const config = {
        onUploadProgress(progressEvent) {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          self.settings.uploading[key] = progress;
        },
      };
      const { data } = await HTTP.post('/media/images', payload, config);
      this.$store.commit(mutations.ADD_TO_GALLERY_FOR_MINISTRY, {
        key: `${key}_gallery`,
        val: data.data.images[0],
      });
    },
    // async saveRole(role) {
    //   const action = role.id === undefined ? actions.DO_CREATE_MINISTRY_ROLE : actions.DO_UPDATE_MINISTRY_ROLE;
    //   const payload = {
    //     id: role.id,
    //     is_head: role.is_head,
    //     ministry_id: this.ministry.id,
    //     staff_member_id: role.staff_member_id,
    //     title: role.title,
    //   };
    //   await this.$store.dispatch(action, payload);
    // },
    // async saveRoles(roles) {
    //   const saveActions = [];
    //   roles.forEach((role) => {
    //     if (role.staff_member_id !== undefined) {
    //       saveActions.push(this.saveRole(role));
    //     }
    //   });
    //   return Promise.all(saveActions);
    // },
    async searchStaffMembers(query) {
      this.settings.loading = true;
      const payload = {
        suggest: {
          suggestions: {
            text: query,
            completion: {
              field: 'suggest',
              contexts: {
                account_id: this.account.id,
              },
            },
          },
        },
      };
      try {
        const { data } = await SEARCH.post('/doxa_staff_members/staff_member/_search', payload);
        const results = data.suggest.suggestions;
        if (results.length > 0) {
          this.options = _.map(results[0].options, '_source');
        } else {
          this.options = [];
        }
        this.settings.loading = false;
      } catch (error) {
        this.settings.loading = false;
      }
    },
    set(val, key) {
      if (key === 'name') this.setKey(val);
      this.$store.commit(mutations.SET_MINISTRY_FIELD, {
        key,
        val,
      });
    },
    setKey(val) {
      if (val !== undefined) {
        const slug = val.toString().toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^\w-]+/g, '')
          .replace(/--+/g, '-')
          .replace(/^-+/, '')
          .replace(/-+$/, '');
        this.$store.commit(mutations.SET_MINISTRY_FIELD, {
          key: 'key',
          val: slug,
        });
      }
    },
    // setRole(val, index, key) {
    //   this.$store.commit(mutations.SET_FIELD_FOR_ROLE_FOR_MINISTRY, {
    //     index,
    //     key,
    //     val,
    //   });
    // },
    // setStaffMember(selected, index) {
    //   const ids = _.map(this.ministry._embedded.roles, 'staff_member_id');
    //   if (ids.includes(selected.id)) {
    //     this.$buefy.alert.open({
    //       message: `A ministry role already exists for ${selected.full_name}`,
    //       type: 'is-danger',
    //     });
    //   } else {
    //     this.setRole(selected.id, index, 'staff_member_id');
    //   }
    // },
    sortImages(val, key) {
      this.$store.commit(mutations.SORT_GALLERY_FOR_MINISTRY, {
        key,
        from: val.from,
        to: val.to,
      });
    },
    async submit() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        this.settings.submitting = true;
        const action = this.isNew ? actions.DO_CREATE_MINISTRY : actions.DO_UPDATE_MINISTRY;
        const payload = {
          id: this.ministry.id,
          age_range: this.ministry.age_range,
          contact_name: this.ministry.contact_name,
          contact_title: this.ministry.contact_title,
          key: this.ministry.key,
          email: this.ministry.email,
          main_body: this.ministry.main_body,
          main_gallery_ids: _.map(this.ministry._embedded.main_gallery, 'id').join(','),
          main_heading: this.ministry.main_heading,
          name: this.ministry.name,
          service_body: this.ministry.service_body,
          service_gallery_ids: _.map(this.ministry._embedded.service_gallery, 'id').join(','),
          service_heading: this.ministry.service_heading,
          short_desc: this.ministry.short_desc,
          social_facebook: this.ministry.social.facebook,
          social_instagram: this.ministry.social.instagram,
          social_twitter: this.ministry.social.twitter,
          social_youtube: this.ministry.social.youtube,
          phone_number: this.ministry.phone_number,
          zoom: 'header_image,main_gallery,profile_image,service_gallery',
        };
        if (this.images.contact) {
          const file = this.images.contact.generateDataUrl('image/jpeg');
          const { data } = await this.$store.dispatch(actions.DO_CREATE_MEDIA_IMAGE, { file });
          payload.contact_image_id = data.images[0].id;
        }
        if (this.images.header) {
          const file = this.images.header.generateDataUrl('image/jpeg');
          const { data } = await this.$store.dispatch(actions.DO_CREATE_MEDIA_IMAGE, { file });
          payload.header_image_id = data.images[0].id;
        }
        if (this.images.profile) {
          const file = this.images.profile.generateDataUrl('image/jpeg');
          const { data } = await this.$store.dispatch(actions.DO_CREATE_MEDIA_IMAGE, { file });
          payload.profile_image_id = data.images[0].id;
        }
        try {
          // const roles = this.ministry._embedded.roles;
          const response = await this.$store.dispatch(action, payload);
          // await this.saveRoles(roles);
          this.$parent.close();
          this.$store.commit(mutations.SET_APP_SNACKBAR, {
            type: 'is-success',
            message: response.message,
          });
          this.settings.submitting = false;
          this.$store.commit(mutations.SET_MINISTRY_REFRESH, true);
        } catch (error) {
          this.settings.submitting = false;
          this.$store.commit(mutations.SET_APP_SNACKBAR, {
            type: 'is-danger',
            message: error.response.data.data.error_message,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
#ministry-form {
  .ministry-roles {
    min-height: 295px;
  }
  .media {
    margin-bottom: 0.75rem;
  }
  table.table {
    tr {
      td, th {
        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          padding-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/MinistryForm.vue